import DOMPurify from "dompurify";

/**
 * Allowlist aligned with `credible-loan-application-service` GLOBAL_HTML_SANITIZE_OPTIONS.
 * Display-only: no pre/post entity decode, no https URL skip.
 */
const RICH_TEXT_ALLOWED_TAGS = [
  "b",
  "i",
  "em",
  "strong",
  "u",
  "p",
  "br",
  "ul",
  "ol",
  "li",
  "span",
  "blockquote",
  "code",
];

export function sanitize(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: RICH_TEXT_ALLOWED_TAGS,
    ALLOWED_ATTR: ["style"],
  });
}
